<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'SINCRONIZACION.LBL_SINCRONIZACION' | translate}}">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fSincronizacion" name="fSincronizacion">
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'SINCRONIZACION.LBL_CODIGO' | translate }}</label>
                <input type="text" pInputText id="codigo"
                       name="nomCodigo"
                       autocomplete="off"
                       formControlName="codigo"
                       maxlength="20"
                       (blur)="validarCodigo()"
                       codigos-reactive
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                  {{ 'SINCRONIZACION.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                  {{ 'MSG_CODIGOEXISTE' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'SINCRONIZACION.LBL_TABLA' | translate }}</label>
                <input type="text" pInputText id="nombre"
                       name="nomNombre"
                       autocomplete="off"
                       formControlName="tabla"
                       [maxlength]="100" (blur)="validarTabla()"
                       sin-caracteres-especiales-reactive>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tabla.invalid">
                  {{ 'SINCRONIZACION.LBL_TABLA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <div class="p-message p-messages-error p-corner-all" *ngIf="tabExiste">
                  {{ 'SINCRONIZACION.MSG_TABLAEXISTE' | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <p-checkbox label="{{ 'SINCRONIZACION.LBL_SIEMPRESINCRONIZA' | translate}}" binary="true"
                          id="idSiempreSincroniza"
                          name="nomSiempreSincroniza"
                          formControlName="indicadorTablaEstatica"></p-checkbox>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                          id="indicador"
                          name="nomIndicador"
                          formControlName="indicadorHabilitado"></p-checkbox>
            </div>
          </div>

          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </p-panel>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
